module.exports = __webpack_public_path__ + "static/media/eugenio-perrier.7fca10d9.jpeg";